/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetContractEstimateItemDto } from './GetContractEstimateItemDto';
import {
    GetContractEstimateItemDtoFromJSON,
    GetContractEstimateItemDtoFromJSONTyped,
    GetContractEstimateItemDtoToJSON,
} from './GetContractEstimateItemDto';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetEstimateByMonthDto } from './GetEstimateByMonthDto';
import {
    GetEstimateByMonthDtoFromJSON,
    GetEstimateByMonthDtoFromJSONTyped,
    GetEstimateByMonthDtoToJSON,
} from './GetEstimateByMonthDto';
import type { GetPositionDto } from './GetPositionDto';
import {
    GetPositionDtoFromJSON,
    GetPositionDtoFromJSONTyped,
    GetPositionDtoToJSON,
} from './GetPositionDto';
import type { GetProfileCategoryDto } from './GetProfileCategoryDto';
import {
    GetProfileCategoryDtoFromJSON,
    GetProfileCategoryDtoFromJSONTyped,
    GetProfileCategoryDtoToJSON,
} from './GetProfileCategoryDto';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetEstimateItemContractDto
 */
export interface GetEstimateItemContractDto {
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    id: string;
    /**
     * 
     * @type {GetEstimateByMonthDto}
     * @memberof GetEstimateItemContractDto
     */
    estimateByMonth: GetEstimateByMonthDto;
    /**
     * 
     * @type {Date}
     * @memberof GetEstimateItemContractDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEstimateItemContractDto
     */
    endDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    importFileName: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesInvoicesSum: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchaseInvoicesSum: string;
    /**
     * 
     * @type {GetPositionDto}
     * @memberof GetEstimateItemContractDto
     */
    position: GetPositionDto;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    positionType: GetEstimateItemContractDtoPositionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    rcSalesTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesSurchargePercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesDiscountPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesNet: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesCommissionPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesCommissionAmount: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesNetTechnicalCost: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesBeerTax: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesPrintingCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesOperatingFee: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesBlockSurcharge: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesTransferCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesNetTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    rcPurchase: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchaseTechnicalCost: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchaseBeerTax: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchasePrintingCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchaseOperatingFee: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchaseBlockSurcharge: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchaseTransferCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchaseDiscountPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchaseNetTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchaseNet: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    purchaseSurchargePercent: string;
    /**
     * 
     * @type {GetProfileCategoryDto}
     * @memberof GetEstimateItemContractDto
     */
    profileCategory: GetProfileCategoryDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetEstimateItemContractDto
     */
    isUpSell: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    netCustomerAccount: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    numberOfMedia: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    additionalDescription: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    orderNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    ownName: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    technologyDictionary: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    regionDictionary: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    formatRadio: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    formatPress: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    formatInternet: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    emissionTypeRadio: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    emissionTypeCinema: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    purchaseFormInternet: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    categoryInternet: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    categoryLabcon: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    copySize: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    purchaseMethod: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    medium: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    labconChannel: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    ballDictionary: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    salesCommissionSum: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    service: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    actionGroup: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    serviceExternalWorkPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    serviceCreationPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    serviceChangeProductionPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    serviceStrategyPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    serviceProductionBroadcastPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemContractDto
     */
    serviceClientServicePercent: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEstimateItemContractDto
     */
    clone?: boolean;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    countryDictionary?: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemContractDto
     */
    pathPhaseDictionary?: GetDictionaryDto;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetEstimateItemContractDto
     */
    specialistTeam?: GetTeamDto;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetEstimateItemContractDto
     */
    deliveryTeam?: GetTeamDto;
    /**
     * 
     * @type {Array<GetContractEstimateItemDto>}
     * @memberof GetEstimateItemContractDto
     */
    contractEstimateItems: Array<GetContractEstimateItemDto>;
}


/**
 * @export
 */
export const GetEstimateItemContractDtoPositionTypeEnum = {
    Standard: 'Standard',
    Commission: 'Commission',
    TransferredCommission: 'TransferredCommission',
    TechnicalCost: 'TechnicalCost'
} as const;
export type GetEstimateItemContractDtoPositionTypeEnum = typeof GetEstimateItemContractDtoPositionTypeEnum[keyof typeof GetEstimateItemContractDtoPositionTypeEnum];


/**
 * Check if a given object implements the GetEstimateItemContractDto interface.
 */
export function instanceOfGetEstimateItemContractDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "estimateByMonth" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "comment" in value;
    isInstance = isInstance && "importFileName" in value;
    isInstance = isInstance && "salesInvoicesSum" in value;
    isInstance = isInstance && "purchaseInvoicesSum" in value;
    isInstance = isInstance && "position" in value;
    isInstance = isInstance && "positionType" in value;
    isInstance = isInstance && "rcSalesTotal" in value;
    isInstance = isInstance && "salesSurchargePercent" in value;
    isInstance = isInstance && "salesDiscountPercent" in value;
    isInstance = isInstance && "salesNet" in value;
    isInstance = isInstance && "salesCommissionPercent" in value;
    isInstance = isInstance && "salesCommissionAmount" in value;
    isInstance = isInstance && "salesNetTechnicalCost" in value;
    isInstance = isInstance && "salesBeerTax" in value;
    isInstance = isInstance && "salesPrintingCosts" in value;
    isInstance = isInstance && "salesOperatingFee" in value;
    isInstance = isInstance && "salesBlockSurcharge" in value;
    isInstance = isInstance && "salesTransferCosts" in value;
    isInstance = isInstance && "salesNetTotal" in value;
    isInstance = isInstance && "rcPurchase" in value;
    isInstance = isInstance && "purchaseTechnicalCost" in value;
    isInstance = isInstance && "purchaseBeerTax" in value;
    isInstance = isInstance && "purchasePrintingCosts" in value;
    isInstance = isInstance && "purchaseOperatingFee" in value;
    isInstance = isInstance && "purchaseBlockSurcharge" in value;
    isInstance = isInstance && "purchaseTransferCosts" in value;
    isInstance = isInstance && "purchaseDiscountPercent" in value;
    isInstance = isInstance && "purchaseNetTotal" in value;
    isInstance = isInstance && "purchaseNet" in value;
    isInstance = isInstance && "purchaseSurchargePercent" in value;
    isInstance = isInstance && "profileCategory" in value;
    isInstance = isInstance && "isUpSell" in value;
    isInstance = isInstance && "netCustomerAccount" in value;
    isInstance = isInstance && "numberOfMedia" in value;
    isInstance = isInstance && "additionalDescription" in value;
    isInstance = isInstance && "orderNumber" in value;
    isInstance = isInstance && "ownName" in value;
    isInstance = isInstance && "technologyDictionary" in value;
    isInstance = isInstance && "regionDictionary" in value;
    isInstance = isInstance && "formatRadio" in value;
    isInstance = isInstance && "formatPress" in value;
    isInstance = isInstance && "formatInternet" in value;
    isInstance = isInstance && "emissionTypeRadio" in value;
    isInstance = isInstance && "emissionTypeCinema" in value;
    isInstance = isInstance && "purchaseFormInternet" in value;
    isInstance = isInstance && "categoryInternet" in value;
    isInstance = isInstance && "categoryLabcon" in value;
    isInstance = isInstance && "copySize" in value;
    isInstance = isInstance && "purchaseMethod" in value;
    isInstance = isInstance && "medium" in value;
    isInstance = isInstance && "labconChannel" in value;
    isInstance = isInstance && "ballDictionary" in value;
    isInstance = isInstance && "salesCommissionSum" in value;
    isInstance = isInstance && "service" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "actionGroup" in value;
    isInstance = isInstance && "serviceExternalWorkPercent" in value;
    isInstance = isInstance && "serviceCreationPercent" in value;
    isInstance = isInstance && "serviceChangeProductionPercent" in value;
    isInstance = isInstance && "serviceStrategyPercent" in value;
    isInstance = isInstance && "serviceProductionBroadcastPercent" in value;
    isInstance = isInstance && "serviceClientServicePercent" in value;
    isInstance = isInstance && "contractEstimateItems" in value;

    return isInstance;
}

export function GetEstimateItemContractDtoFromJSON(json: any): GetEstimateItemContractDto {
    return GetEstimateItemContractDtoFromJSONTyped(json, false);
}

export function GetEstimateItemContractDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEstimateItemContractDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'estimateByMonth': GetEstimateByMonthDtoFromJSON(json['estimateByMonth']),
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'comment': json['comment'],
        'importFileName': json['importFileName'],
        'salesInvoicesSum': json['salesInvoicesSum'],
        'purchaseInvoicesSum': json['purchaseInvoicesSum'],
        'position': GetPositionDtoFromJSON(json['position']),
        'positionType': json['positionType'],
        'rcSalesTotal': json['rcSalesTotal'],
        'salesSurchargePercent': json['salesSurchargePercent'],
        'salesDiscountPercent': json['salesDiscountPercent'],
        'salesNet': json['salesNet'],
        'salesCommissionPercent': json['salesCommissionPercent'],
        'salesCommissionAmount': json['salesCommissionAmount'],
        'salesNetTechnicalCost': json['salesNetTechnicalCost'],
        'salesBeerTax': json['salesBeerTax'],
        'salesPrintingCosts': json['salesPrintingCosts'],
        'salesOperatingFee': json['salesOperatingFee'],
        'salesBlockSurcharge': json['salesBlockSurcharge'],
        'salesTransferCosts': json['salesTransferCosts'],
        'salesNetTotal': json['salesNetTotal'],
        'rcPurchase': json['rcPurchase'],
        'purchaseTechnicalCost': json['purchaseTechnicalCost'],
        'purchaseBeerTax': json['purchaseBeerTax'],
        'purchasePrintingCosts': json['purchasePrintingCosts'],
        'purchaseOperatingFee': json['purchaseOperatingFee'],
        'purchaseBlockSurcharge': json['purchaseBlockSurcharge'],
        'purchaseTransferCosts': json['purchaseTransferCosts'],
        'purchaseDiscountPercent': json['purchaseDiscountPercent'],
        'purchaseNetTotal': json['purchaseNetTotal'],
        'purchaseNet': json['purchaseNet'],
        'purchaseSurchargePercent': json['purchaseSurchargePercent'],
        'profileCategory': GetProfileCategoryDtoFromJSON(json['profileCategory']),
        'isUpSell': json['isUpSell'],
        'netCustomerAccount': json['netCustomerAccount'],
        'numberOfMedia': json['numberOfMedia'],
        'additionalDescription': json['additionalDescription'],
        'orderNumber': json['orderNumber'],
        'ownName': json['ownName'],
        'technologyDictionary': GetDictionaryDtoFromJSON(json['technologyDictionary']),
        'regionDictionary': GetDictionaryDtoFromJSON(json['regionDictionary']),
        'formatRadio': GetDictionaryDtoFromJSON(json['formatRadio']),
        'formatPress': GetDictionaryDtoFromJSON(json['formatPress']),
        'formatInternet': GetDictionaryDtoFromJSON(json['formatInternet']),
        'emissionTypeRadio': GetDictionaryDtoFromJSON(json['emissionTypeRadio']),
        'emissionTypeCinema': GetDictionaryDtoFromJSON(json['emissionTypeCinema']),
        'purchaseFormInternet': GetDictionaryDtoFromJSON(json['purchaseFormInternet']),
        'categoryInternet': GetDictionaryDtoFromJSON(json['categoryInternet']),
        'categoryLabcon': GetDictionaryDtoFromJSON(json['categoryLabcon']),
        'copySize': GetDictionaryDtoFromJSON(json['copySize']),
        'purchaseMethod': GetDictionaryDtoFromJSON(json['purchaseMethod']),
        'medium': GetDictionaryDtoFromJSON(json['medium']),
        'labconChannel': GetDictionaryDtoFromJSON(json['labconChannel']),
        'ballDictionary': GetDictionaryDtoFromJSON(json['ballDictionary']),
        'salesCommissionSum': json['salesCommissionSum'],
        'service': json['service'],
        'action': json['action'],
        'actionGroup': json['actionGroup'],
        'serviceExternalWorkPercent': json['serviceExternalWorkPercent'],
        'serviceCreationPercent': json['serviceCreationPercent'],
        'serviceChangeProductionPercent': json['serviceChangeProductionPercent'],
        'serviceStrategyPercent': json['serviceStrategyPercent'],
        'serviceProductionBroadcastPercent': json['serviceProductionBroadcastPercent'],
        'serviceClientServicePercent': json['serviceClientServicePercent'],
        'clone': !exists(json, 'clone') ? undefined : json['clone'],
        'countryDictionary': !exists(json, 'countryDictionary') ? undefined : GetDictionaryDtoFromJSON(json['countryDictionary']),
        'pathPhaseDictionary': !exists(json, 'pathPhaseDictionary') ? undefined : GetDictionaryDtoFromJSON(json['pathPhaseDictionary']),
        'specialistTeam': !exists(json, 'specialistTeam') ? undefined : GetTeamDtoFromJSON(json['specialistTeam']),
        'deliveryTeam': !exists(json, 'deliveryTeam') ? undefined : GetTeamDtoFromJSON(json['deliveryTeam']),
        'contractEstimateItems': ((json['contractEstimateItems'] as Array<any>).map(GetContractEstimateItemDtoFromJSON)),
    };
}

export function GetEstimateItemContractDtoToJSON(value?: GetEstimateItemContractDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'estimateByMonth': GetEstimateByMonthDtoToJSON(value.estimateByMonth),
        'startDate': (value.startDate.toISOString()),
        'endDate': (value.endDate.toISOString()),
        'comment': value.comment,
        'importFileName': value.importFileName,
        'salesInvoicesSum': value.salesInvoicesSum,
        'purchaseInvoicesSum': value.purchaseInvoicesSum,
        'position': GetPositionDtoToJSON(value.position),
        'positionType': value.positionType,
        'rcSalesTotal': value.rcSalesTotal,
        'salesSurchargePercent': value.salesSurchargePercent,
        'salesDiscountPercent': value.salesDiscountPercent,
        'salesNet': value.salesNet,
        'salesCommissionPercent': value.salesCommissionPercent,
        'salesCommissionAmount': value.salesCommissionAmount,
        'salesNetTechnicalCost': value.salesNetTechnicalCost,
        'salesBeerTax': value.salesBeerTax,
        'salesPrintingCosts': value.salesPrintingCosts,
        'salesOperatingFee': value.salesOperatingFee,
        'salesBlockSurcharge': value.salesBlockSurcharge,
        'salesTransferCosts': value.salesTransferCosts,
        'salesNetTotal': value.salesNetTotal,
        'rcPurchase': value.rcPurchase,
        'purchaseTechnicalCost': value.purchaseTechnicalCost,
        'purchaseBeerTax': value.purchaseBeerTax,
        'purchasePrintingCosts': value.purchasePrintingCosts,
        'purchaseOperatingFee': value.purchaseOperatingFee,
        'purchaseBlockSurcharge': value.purchaseBlockSurcharge,
        'purchaseTransferCosts': value.purchaseTransferCosts,
        'purchaseDiscountPercent': value.purchaseDiscountPercent,
        'purchaseNetTotal': value.purchaseNetTotal,
        'purchaseNet': value.purchaseNet,
        'purchaseSurchargePercent': value.purchaseSurchargePercent,
        'profileCategory': GetProfileCategoryDtoToJSON(value.profileCategory),
        'isUpSell': value.isUpSell,
        'netCustomerAccount': value.netCustomerAccount,
        'numberOfMedia': value.numberOfMedia,
        'additionalDescription': value.additionalDescription,
        'orderNumber': value.orderNumber,
        'ownName': value.ownName,
        'technologyDictionary': GetDictionaryDtoToJSON(value.technologyDictionary),
        'regionDictionary': GetDictionaryDtoToJSON(value.regionDictionary),
        'formatRadio': GetDictionaryDtoToJSON(value.formatRadio),
        'formatPress': GetDictionaryDtoToJSON(value.formatPress),
        'formatInternet': GetDictionaryDtoToJSON(value.formatInternet),
        'emissionTypeRadio': GetDictionaryDtoToJSON(value.emissionTypeRadio),
        'emissionTypeCinema': GetDictionaryDtoToJSON(value.emissionTypeCinema),
        'purchaseFormInternet': GetDictionaryDtoToJSON(value.purchaseFormInternet),
        'categoryInternet': GetDictionaryDtoToJSON(value.categoryInternet),
        'categoryLabcon': GetDictionaryDtoToJSON(value.categoryLabcon),
        'copySize': GetDictionaryDtoToJSON(value.copySize),
        'purchaseMethod': GetDictionaryDtoToJSON(value.purchaseMethod),
        'medium': GetDictionaryDtoToJSON(value.medium),
        'labconChannel': GetDictionaryDtoToJSON(value.labconChannel),
        'ballDictionary': GetDictionaryDtoToJSON(value.ballDictionary),
        'salesCommissionSum': value.salesCommissionSum,
        'service': value.service,
        'action': value.action,
        'actionGroup': value.actionGroup,
        'serviceExternalWorkPercent': value.serviceExternalWorkPercent,
        'serviceCreationPercent': value.serviceCreationPercent,
        'serviceChangeProductionPercent': value.serviceChangeProductionPercent,
        'serviceStrategyPercent': value.serviceStrategyPercent,
        'serviceProductionBroadcastPercent': value.serviceProductionBroadcastPercent,
        'serviceClientServicePercent': value.serviceClientServicePercent,
        'clone': value.clone,
        'countryDictionary': GetDictionaryDtoToJSON(value.countryDictionary),
        'pathPhaseDictionary': GetDictionaryDtoToJSON(value.pathPhaseDictionary),
        'specialistTeam': GetTeamDtoToJSON(value.specialistTeam),
        'deliveryTeam': GetTeamDtoToJSON(value.deliveryTeam),
        'contractEstimateItems': ((value.contractEstimateItems as Array<any>).map(GetContractEstimateItemDtoToJSON)),
    };
}

